import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polyline, { points: "6 9 6 2 18 2 18 9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Rect, { width: "12", height: "8", x: "6", y: "14", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Printer";
const Printer = memo(themed(Icon));
export {
  Printer
};
//# sourceMappingURL=printer.js.map
